import TypeNews from "./TypeNews";
import _ from "lodash";

class Xhr {
	defaultData = {
		domain      : `https://platform.dev20bet.com/api`,
		cors        : 'cors=1',
		credentials : 'include',
		optionsGet  : {
			mode   : 'cors',
			method : 'get'
		},
		optionsPost : {
			mode     : 'cors',
			method   : 'post',
			headers  : {
				"Content-type" : "application/x-www-form-urlencoded; charset=UTF-8",
			},
			body     : {},
			redirect : 'follow'
		}
	};

	/**
	 * Выполнить GET-запрос
	 * @param url
	 * @param params
	 * @param isAuth
	 * @returns {Promise<any>}
	 */
	get(url, params = '', isNeedAuth = false) {
		if ( isNeedAuth ) {
			const token = localStorage.getItem('token');
			if ( token ) {
				params = `${params}&atoken=${token}`;
			}
		}

		url = `${this.defaultData.domain}${url}`;

		if ( this.defaultData.cors === '' ) {
			url = `${url}?${params}`;
		} else {
			url = `${url}?${this.defaultData.cors}&${params}`;
		}

		return fetch(url, this.defaultData.optionsGet)
			.then(response => {
				if ( response.status >= 200 && response.status < 300 ) {
					return Promise.resolve(response);
				}

				return Promise.reject(new Error(response.statusText));
			})
			.then(response => response.json())
			.catch(error => {
				console.error('Request failed: ', error);
			});
	}

	/**
	 * выполнить POST-запрос
	 * @param url
	 * @param data
	 * @returns {Promise<any>}
	 */
	post(url, data, isLocal = false) {
		const tokenData = localStorage.getItem('token');
		const token = tokenData ? `&atoken=${tokenData}` : '';

		if ( !isLocal ) {
			url = `${this.defaultData.domain}${url}?${this.defaultData.cors}${token}`;
		} else {
			url = `http://maxline.local${url}?${this.defaultData.cors}${token}`;
		}

		const formData = [];
		_.mapKeys(data, (value, key) => {
			formData.push(`${key}=${value}`);
		});

		this.defaultData.optionsPost.body = formData.join('&');

		return fetch(`${url}`, this.defaultData.optionsPost)
			.then(response => {
				// TODO: Redirect processing

				if ( response.status >= 200 && response.status < 300 ) {
					return Promise.resolve(response);
				}

				return Promise.reject(new Error(response.statusText));
			})
			.then(response => response.json())
			.catch(error => {
				console.error('Request failed: ', error);
			});
	}

	upload(url, formData) {
		const tokenData = localStorage.getItem('token');
		const token = tokenData ? `&atoken=${tokenData}` : '';

		url = `${this.defaultData.domain}${url}?${this.defaultData.cors}${token}`;

		return fetch(url, {
			method : "POST",
			body   : formData
		}).then(response => {
			if ( response.status >= 200 && response.status < 300 ) {
				return Promise.resolve(response);
			}

			return Promise.reject(new Error(response.statusText));
		})
			.then(response => response.json())
			.catch(error => {
				console.error('Request failed: ', error);
			});

		//return $.ajax.post(url, formData, {processData : false, contentType : false});
	}

	/**
	 * проверка авторизации
	 * @returns {*}
	 */
	static isAuth() {
		const xhr = new Xhr();
		return xhr.get('/user/is-auth', '', true);
	}

	/**
	 * авторизация
	 * @param login
	 * @param password
	 * @returns {*}
	 */
	static login(login, password) {
		const xhr = new Xhr();
		return xhr.get('/user/login', [`login=${login}`, `password=${password}`].join('&'));
	}

	/**
	 * получение информации о пользователе
	 *
	 * @returns {*}
	 */
	static getInfo() {
		const xhr = new Xhr();
		return xhr.get('/user/get-info', '', true);
	}

	static getCash() {
		const xhr = new Xhr();
		return xhr.get('/user/get-cash', '', true);
	}

	/**
	 * спорты в левом меню
	 *
	 * @returns {*}
	 */
	static getLine(period = 0) {
		const xhr = new Xhr();
		return xhr.get('/sport/line', `period=${period}`);
	}

	static getSports() {
		const xhr = new Xhr();
		return xhr.get('/sport/list');
	}

	/**
	 * популярные в левом меню
	 * @returns {*}
	 */
	static getPopulars(period = 0) {
		const xhr = new Xhr();
		return xhr.get('/popular/line-menu', `period=${period}`);
	}

	/**
	 * лиги по спорту в левом меню
	 *
	 * @param sportId
	 * @param period
	 * @returns {*}
	 */
	static getLeague(sportId, period = 0) {
		const xhr = new Xhr();
		return xhr.get(`/league/line/${sportId}/${period}`);
	}

	/**
	 * лайв на главной странице
	 * @returns {*}
	 */
	static getLiveNow() {
		const xhr = new Xhr();
		return xhr.get('/event/live-now');
	}

	/**
	 * получить live-скоро
	 * @returns {*}
	 */
	static getLiveSoon() {
		const xhr = new Xhr();
		return xhr.get('/event/live-soon');
	}

	/**
	 * получить live по событиям
	 *
	 * @param eventIds
	 * @param is_admin
	 * @returns {*}
	 */
	static getLiveData(eventIds, is_admin = false) {
		const xhr = new Xhr();

		if ( is_admin ) {
			return xhr.get('/event/live-data', `id=${eventIds}&is_admin=${+is_admin}`, true);
		} else {
			return xhr.get('/event/live-data', `id=${eventIds}`);
		}
	}

	/**
	 * получить live по спортам
	 *
	 * @param sportIds
	 * @param is_admin
	 * @returns {*}
	 */
	static getLiveDataBySports(sportIds, is_admin = false) {
		const xhr = new Xhr();

		if ( is_admin ) {
			return xhr.get('/event/live-data', `sport=${sportIds}&is_admin=${+is_admin}`, true);
		} else {
			return xhr.get('/event/live-data', `sport=${sportIds}`);
		}
	}

	/**
	 * получить баннеры
	 *
	 * @returns {*}
	 */
	static getBanners() {
		const xhr = new Xhr();
		return xhr.get('/banners/all');
	}

	/**
	 * получение линии
	 *
	 * @param leagues
	 * @param eventId
	 * @param sportId
	 * @param period
	 * @returns {*}
	 */
	static getLineData(leagues, eventId = null, sportId = null, period = 0) {
		const xhr = new Xhr();
		let params = [`period=${period}`];

		if ( leagues !== null ) {
			params.push(`league=${leagues}`)
		}

		if ( eventId !== null ) {
			params.push(`eventId=${eventId}`);
		}

		if ( sportId !== null ) {
			params.push(`sport=${sportId}`);
		}

		return xhr.get('/event/line-data', params.join('&'));
	}

	/**
	 * получение линии популярных
	 *
	 * @param data
	 * @returns {*}
	 */
	static getLineDataSeveral(data) {
		const xhr = new Xhr();
		let params = [`params=${data}`];
		return xhr.get('/popular/line-data-several', params.join('&'));
	}

	/**
	 * Получить популярные
	 *
	 * @param sportSlug
	 * @param popularSlug
	 * @param period
	 * @returns {*}
	 */
	static getPopularLineData(sportSlug, popularSlug = null, period = 0) {
		const xhr = new Xhr();
		return xhr.get('/popular/line-data', [`sportSlug=${sportSlug}`, `popularSlug=${popularSlug}`,
		                                      `period=${period}`].join('&'));
	}

	/**
	 * получить линию по спортам
	 *
	 * @param sports
	 * @returns {*}
	 */
	static getLineSelect(sports) {
		const xhr = new Xhr();
		return xhr.get('/league/line-select', `sport=${sports}`, true);
	}

	/**
	 * получение новостей
	 *
	 * @param type
	 * @param limit
	 * @returns {*}
	 */
	static getLastNews(type, limit = 50) {
		const catId = TypeNews.getIdByType(type);
		const xhr = new Xhr();
		return xhr.get('/news/last', [`catId=${catId}`, `limit=${limit}`].join('&'));
	}

	/**
	 * получение конкретной новости
	 *
	 * @param slug
	 * @param link
	 * @returns {*}
	 */
	static getNewsOne(slug, link = '') {
		const xhr = new Xhr();
		const params = `link=${link.replace('?link=', '')}`;
		return xhr.get(`/news/one/${slug}`, params);
	}

	/**
	 * получить купон
	 *
	 * @param type
	 * @returns {*}
	 */
	static getCoupon(type) {
		const xhr = new Xhr();
		return xhr.get('/coupon/is-fresh', [`type=${type === 'live' ? 1 : 0}`].join('&'), true);
	}

	static getCouponLine(type) {
		const xhr = new Xhr();
		return xhr.get('/coupon/get', [`type=${type === 'live' ? 1 : 0}`, 'system=1'].join('&'), true);
	}

	static couponAdd(eventId, hash) {
		const xhr = new Xhr();
		return xhr.get('/coupon/add', [`event_id=${eventId}`, `hash=${hash}`].join('&'), true);
	}

	static couponNext(type) {
		const xhr = new Xhr();
		return xhr.get('/coupon/next', [`type=${type === 'live' ? 1 : 0}`].join('&'), true);
	}

	static couponPrev(type) {
		const xhr = new Xhr();
		return xhr.get('/coupon/prev', [`type=${type === 'live' ? 1 : 0}`].join('&'), true);
	}

	static couponClear(type) {
		const xhr = new Xhr();
		return xhr.get('/coupon/clear', [`type=${type === 'live' ? 1 : 0}`].join('&'), true);
	}

	static couponDel(type, event_id) {
		const xhr = new Xhr();
		return xhr.get('/coupon/del', [`type=${type === 'live' ? 1 : 0}`, `event_id=${event_id}`].join('&'), true);
	}

	static setGoldBet(gold, type, system = 0) {
		const xhr = new Xhr();
		return xhr.get('/coupon/set-gold-bet', [`type=${type === 'live' ? 1 : 0}`, `gold=${gold}`,
		                                        `system=${system}`].join('&'), true);
	}

	static setLiveOpt(option) {
		const xhr = new Xhr();
		return xhr.get('/user/live-opt', [`option=${option}`].join('&'), true);
	}

	/**
	 * история операций
	 *
	 * @param period
	 * @returns {*}
	 */
	static betHistory(period = 0) {
		const xhr = new Xhr();
		return xhr.get(`/user/bet-history`, [`period=${period}`].join('&'), true);
	}

	/**
	 * история платежей
	 *
	 * @param period
	 * @returns {*}
	 */
	static paymentHistory(period = 0) {
		const xhr = new Xhr();
		return xhr.get(`/payment/history`, [`period=${period}`].join('&'), true);
	}

	/**
	 * отмена выплаты
	 *
	 * @param payment_id
	 * @returns {*}
	 */
	static paymentCancel(payment_id) {
		const xhr = new Xhr();
		return xhr.get(`/payment/cancel`, [`id=${payment_id}`].join('&'), true);
	}

	/**
	 * вывод через банк
	 * @param data {amount,bank,mfo,unn,account,type,numberMail,bankId}
	 * @returns {*}
	 */
	static bankOut(data) {
		const xhr = new Xhr();
		return xhr.post('/payment/bank-out', data);
	}

	/**
	 * вывод через кассу
	 * @param data {amount,cash}
	 * @returns {*}
	 */
	static cashOut(data) {
		const xhr = new Xhr();
		return xhr.post('/payment/cash-out', data);
	}

	/**
	 * вывод через белинвестбанк
	 * @param data {amount, phone}
	 * @returns {*}
	 */
	static cashOutInvestbank(data) {
		const xhr = new Xhr();
		return xhr.post('/payment/belinvest-cash-out', data);
	}

	/**
	 * вывод на мобильный телефон
	 * @param data {amount, phone}
	 * @returns {*}
	 */
	static cashOutMobile(data) {
		const xhr = new Xhr();
		return xhr.post('/payment/mobile-out', data);
	}

	/**
	 * пополнение
	 * @param data
	 * @returns {*}
	 */
	static cashIn(data) {
		const xhr = new Xhr();
		return xhr.get('/payment/pay-in-by-3d', `amount=${data}`, true);
	}

	static forgotPassword(data) {
		const xhr = new Xhr();
		return xhr.post('/user/forgot', data);
	}

	static restorePassword(hash) {
		// /user/restore-password/VL6PDEqiGc2ujEugZzjZXNLpfwVYog22GUGshpKIs
		// GET
		const xhr = new Xhr();
		return xhr.get(`/user/restore-password/${hash}`);
	}

	static restorePasswordPost(hash, data) {
		const xhr = new Xhr();
		return xhr.post(`/user/restore-password/${hash}`, data);
	}

	static changePassword() {
		// /user/changePassword
		const xhr = new Xhr();
		return xhr.get('/user/changePassword', '', true);
	}

	static changePasswordPost(data) {
		const xhr = new Xhr();
		return xhr.post('/user/change-password', data);
	}

	static resultLive() {
		const xhr = new Xhr();
		return xhr.get('/result/live');
	}

	static resultLine(date) {
		const xhr = new Xhr();
		return xhr.get('/result/line', `date=${date}`);
	}

	static lineSettings() {
		const xhr = new Xhr();
		return xhr.get('/data/line-settings');
	}

	static getLiveMenu() {
		// http://maxline.by/event/live-now?menu
		// TODO: live widget
		const xhr = new Xhr();
		return xhr.get('/event/live-now', ['menu'].join('&'));
	}

	static search(data) {
		const xhr = new Xhr();
		return xhr.post('/search', data);
	}

	static makeBet(type, data) {
		const amount = data['amount'] || 0;
		const clear = data['clear'] || 1;
		const gold = data['gold'] || 1;

		const xhr = new Xhr();
		return xhr.get(`/bet/${type}`, [`amount=${amount}`, `clear=${clear}`, `gold=${gold}`].join('&'), true);
	}

	static makeLineBet(data) {
		const xhr = new Xhr();
		return xhr.post('/bet/line', data);
	}

	static setFactor(eventId, factor) {
		const data = {
			id     : eventId,
			factor : JSON.stringify(factor)
		};

		const xhr = new Xhr();
		return xhr.post('/admin/change-factor', data);
	}

	static getBetgamesData() {
		const xhr = new Xhr();
		return xhr.get(`/data/get-betgames-data`, '', true);
	}

	static register(data) {
		const xhr = new Xhr();
		return xhr.post('/user/sign-up', data);
	}

	static loadPassport(formData) {
		// /user/passport-upload
		const xhr = new Xhr();
		return xhr.upload('/user/passport-upload', formData);
	}

	static changeLeague(data) {
		const xhr = new Xhr();
		return xhr.post('/admin/change-league-data', data);
	}

	static changeLeagueLive(data) {
		const xhr = new Xhr();
		return xhr.post('/admin/change-league-live-data', data);
	}
}

export default Xhr;


// WEBPACK FOOTER //
// ./src/app/helpers/Xhr.js